import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'visibility',
    templateUrl: 'visibility.component.html',
    styleUrls: ['visibility.component.scss'],
})
export class VisibilityComponent implements OnInit {
    @Input() public value;

    public ngOnInit() {}

}
